"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserDetailsController = function () {
  function UserDetailsController($stateParams, UsersService, AppContextService, NotificationService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UserDetailsController);
    this.usersService = UsersService;
    this.appContextService = AppContextService;
    console.log($stateParams.userId);
    this.userId = $stateParams.userId;
    this.getUserDetails(this.userId);
    this.imageBaseUrl = _env2.default.getStorageUrl() + "images/";
    this.deleteIntercomAccount = true;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.isDeletingAccount = false;
    this.requestedDeletedAccount = false;
  }

  (0, _createClass3.default)(UserDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      this.tabTypes = {
        PROFILE: 1,
        PAYMENT: 2,
        JOBS_AND_RATINGS: 3,
        CERTIFICATES: 4,
        MESSAGES: 5,
        RATINGS: 6,
        TIMESHEET: 7
      };

      this.creditAccountReasonOptions = [{ value: _constants2.default.walletTransactionReason.SPECIAL_OFFER, label: "Special Offer" }, { value: _constants2.default.walletTransactionReason.JOB_CANCELLED_BY_HELPER, label: "Job Cancelled by Helper" }, { value: _constants2.default.walletTransactionReason.ADMIN_ACTION, label: "Other" }];
    }
  }, {
    key: "getUserDetails",
    value: function getUserDetails(userId) {
      var _this = this;

      this.isLoading = true;

      this.usersService.getUserDetails(userId, function (response) {
        console.log(response.data);

        _this.user = response.data;
        _this.isLoading = false;

        _this.getTabs();

        _this.$scope.$apply();
      }, function (error) {
        _this.isLoading = false;
      });
    }
  }, {
    key: "getTabs",
    value: function getTabs() {
      if (this.isClient()) {
        var _tabs;

        this.tabs = (_tabs = {}, (0, _defineProperty3.default)(_tabs, this.tabTypes.PROFILE, {
          key: 1,
          label: "PROFILE",
          isActive: true,
          icon: "fa fa-user"
        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.PAYMENT, {
          key: 2,
          label: "PAYMENT",
          isActive: false,
          icon: "fa fa-dollar"
        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.MESSAGES, {
          key: 4,
          label: "MESSAGES",
          isActive: false,
          icon: "fa fa-envelope"
        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.RATINGS, {
          key: 6,
          label: "RATINGS",
          isActive: false,
          icon: "fa fa-star"
        }), (0, _defineProperty3.default)(_tabs, this.tabTypes.TIMESHEET, {
          key: 7,
          label: "TIMESHEET",
          isActive: false,
          icon: "fa fa-clock-o"
        }), _tabs);
      } else {
        var _tabs2;

        this.tabs = (_tabs2 = {}, (0, _defineProperty3.default)(_tabs2, this.tabTypes.PROFILE, {
          key: 1,
          label: "PROFILE",
          isActive: true,
          icon: "fa fa-user"
        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.PAYMENT, {
          key: 2,
          label: "PAYMENT",
          isActive: false,
          icon: "fa fa-dollar"
        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.CERTIFICATES, {
          key: 3,
          label: "CERTIFICATES",
          isActive: false,
          icon: "fa fa-user"
        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.JOBS_AND_RATINGS, {
          key: 4,
          label: "JOBS & RATINGS",
          isActive: false,
          icon: "fa fa-user"
        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.MESSAGES, {
          key: 5,
          label: "MESSAGES",
          isActive: false,
          icon: "fa fa-envelope"
        }), (0, _defineProperty3.default)(_tabs2, this.tabTypes.TIMESHEET, {
          key: 7,
          label: "TIMESHEET",
          isActive: false,
          icon: "fa fa-clock-o"
        }), _tabs2);
      }

      this.activeTab = this.tabs["1"];
    }
  }, {
    key: "switchTab",
    value: function switchTab(tab) {
      var _this2 = this;

      this.activeTab = tab;

      (0, _keys2.default)(this.tabs).map(function (i) {
        if (_this2.tabs[i] == _this2.activeTab) _this2.tabs[i].isActive = true;else _this2.tabs[i].isActive = false;
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      return _common2.default.formatDate(date);
    }
  }, {
    key: "isClient",
    value: function isClient() {
      return this.user && this.user.entityType == _constants2.default.entityType.CLIENT;
    }
  }, {
    key: "isHidden",
    value: function isHidden() {
      return this.user && this.user.isHidden;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.user && this.user.isDisabled;
    }
  }, {
    key: "isProvider",
    value: function isProvider() {
      return this.user && this.user.entityType == _constants2.default.entityType.PROVIDER;
    }
  }, {
    key: "onRatingUpdated",
    value: function onRatingUpdated(totalRatingsAvg) {
      if (this.isClient()) {
        this.user.clientInfo.ratingsAvg = totalRatingsAvg;
      } else {
        this.user.providerInfo.ratingsAvg = totalRatingsAvg;
      }
    }
  }, {
    key: "loginAsUser",
    value: function loginAsUser(targetDevice) {
      var _this3 = this;

      this.usersService.getLoginAsUserAccessToken(this.userId, function (response) {
        console.log("Access token::", response.data);
        _this3.redirectToTarget(targetDevice, response.data.accessToken, _this3.user.country);
      }, function (error) {});
    }
  }, {
    key: "redirectToTarget",
    value: function redirectToTarget(targetDevice, token, country) {
      var rootUrl = _env2.default.getLoginAsBaseUrl(targetDevice, country);
      var url = rootUrl + ("?admin_mode=1&access_token=" + token);
      console.log(url);
      window.open(rootUrl + ("?admin_mode=1&access_token=" + token));
    }
  }, {
    key: "hasGlobalAdminAccess",
    value: function hasGlobalAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "hasLoginAsUserAccess",
    value: function hasLoginAsUserAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasLoginAsUserAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "openConfirmDeleteDialog",
    value: function openConfirmDeleteDialog() {
      var dialog = $("#confirm-delete-dialog").data("kendoDialog");
      dialog.open();
    }

    // ****************//
    // Reset Password  //
    // ****************//

  }, {
    key: "openResetPasswordDialog",
    value: function openResetPasswordDialog() {
      var _this4 = this;

      this.resetPasswordValidator.hideMessages();
      this.resetPasswordDialog.open();
      this.resetPasswordDialog.bind("close", function () {
        return _this4.clearResetPasswordDialog();
      });
    }
  }, {
    key: "closeResetPasswordDialog",
    value: function closeResetPasswordDialog() {
      this.clearResetPasswordDialog();
      this.resetPasswordDialog.close();
    }
  }, {
    key: "clearResetPasswordDialog",
    value: function clearResetPasswordDialog() {
      this.newPassword = "";
      this.repeatPassword = "";
      this.passwordsDoNotMatch = false;

      this.resetPasswordDialog.unbind("close", this.closeResetPasswordDialog.bind(this));
    }
  }, {
    key: "resetPassword",
    value: function resetPassword() {
      var _this5 = this;

      this.passwordsDoNotMatch = false;

      if (!this.resetPasswordValidator.validate()) return;

      if (this.newPassword != this.repeatPassword) {
        this.passwordsDoNotMatch = true;
        return;
      }

      var payload = {
        newPassword: this.newPassword,
        confirmPassword: this.repeatPassword
      };

      this.usersService.resetPassword(this.userId, payload, function () {
        _this5.closeResetPasswordDialog();
      }, function () {
        _this5.closeResetPasswordDialog();
      });
    }

    // ****************//


    // ****************//
    // Credit Account  //
    // ****************//

  }, {
    key: "openCreditAccountDialog",
    value: function openCreditAccountDialog() {
      this.creditAccountValidator.hideMessages();
      this.creditAccountDialog.open();
      this.creditAccountDialog.bind("close", this.clearCreditAccountDialog.bind(this));
    }
  }, {
    key: "closeCreditAccountDialog",
    value: function closeCreditAccountDialog() {
      this.clearCreditAccountDialog();
      this.creditAccountDialog.close();
    }
  }, {
    key: "clearCreditAccountDialog",
    value: function clearCreditAccountDialog() {
      this.creditAccountReason = undefined;
      this.creditAccountAmount = undefined;

      this.creditAccountDialog.unbind("close", this.clearCreditAccountDialog.bind(this));
    }
  }, {
    key: "creditAccount",
    value: function creditAccount(e) {
      var _this6 = this;

      if (!this.creditAccountValidator.validate()) return;

      var payload = {
        actionType: _constants2.default.adminEntitiesActionType.CREDIT_ACCOUNT_BALANCE,
        transactionReason: this.creditAccountReason,
        transactionAmount: this.creditAccountAmount * 100
      };
      this.usersService.updateUserDetails(this.userId, payload, function () {
        _this6.closeCreditAccountDialog();
      }, function () {
        _this6.closeCreditAccountDialog();
      });
    }

    // ****************//

  }, {
    key: "handleDisableAccountDialog",
    value: function handleDisableAccountDialog() {
      var _this7 = this;

      var message = "Are you sure you want to disable this account?";
      if (confirm(message)) {
        this.usersService.disableAccount(this.userId, function () {
          _this7.user.isDisabled = true;
          alert("This account has been disabled, please allow a few minutes for Bigfoot to update its cache.");
        }, function (err) {
          alert(err.data);
        });
      }
    }
  }, {
    key: "handleReactivateAccountDialog",
    value: function handleReactivateAccountDialog() {
      var _this8 = this;

      var message = "Are you sure you want to want to reactivate this account?";
      if (confirm(message)) {
        this.usersService.reactivateAccount(this.userId, function () {
          _this8.user.isDisabled = false;
          alert("This account has been reactivated, please allow a few minutes for Bigfoot to update its cache.");
        }, function (err) {
          alert(err.data);
        });
      }
    }
  }, {
    key: "handleDeleteAccount",
    value: function handleDeleteAccount() {
      var _this9 = this;

      var message = "Are you sure you want to delete this account? THIS ACTION IS IRREVERSIBLE.";
      if (confirm(message)) {
        this.isDeletingAccount = true;
        this.usersService.deleteUser(this.userId, function () {
          _this9.isDeletingAccount = false;
          alert("This account has been deleted successfully. Please close this window.");
          // window.close();
        }, function (err) {
          _this9.isDeletingAccount = false;
          alert(err.data);
        });
      }
    }
  }, {
    key: "deleteUser",
    value: function deleteUser(e) {
      var payload = { deleteIntercomAccount: this.deleteIntercomAccount };
      this.usersService.deleteUser(this.userId, payload, function () {}, function () {});
    }
  }, {
    key: "getConfirmDeleteDialogOptions",
    value: function getConfirmDeleteDialogOptions() {
      var _this10 = this;

      var options = {
        title: "Are you sure?",
        close: function close() {
          _this10.deleteIntercomAccount = true;
        },
        actions: [{ text: 'No' }, {
          text: 'Yes',
          primary: true,
          action: function action(e) {
            return _this10.deleteUser(e);
          }
        }]
      };

      return _underscore2.default.extend(options, this._getDialogOptions());
    }
  }, {
    key: "getResetPasswordOptions",
    value: function getResetPasswordOptions() {
      var options = {
        title: "Reset Password",
        width: "550px"
      };

      return _underscore2.default.extend(options, this._getDialogOptions());
    }
  }, {
    key: "getCreditAccountDialogOptions",
    value: function getCreditAccountDialogOptions() {
      var options = {
        title: "Credit Account",
        width: "550px"
      };

      return _underscore2.default.extend(options, this._getDialogOptions());
    }
  }, {
    key: "_getDialogOptions",
    value: function _getDialogOptions() {
      return {
        buttonLayout: "normal",
        messages: {
          close: ""
        },
        visible: false,
        closable: true,
        modal: true
      };
    }
  }, {
    key: "handleRefreshCache",
    value: function handleRefreshCache() {
      var _this11 = this;

      var payload = { actionType: _constants2.default.adminEntitiesActionType.REFRESH_CACHE };
      this.usersService.updateUserDetails(this.userId, payload, function () {
        _this11.notificationService.success("Cache refresh successful.");
      }, function () {
        _this11.notificationService.error("Cache refresh failed.");
      });
    }
  }]);
  return UserDetailsController;
}();

exports.default = UserDetailsController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/user-details/user-details.controller.js
 **/